export default "__VITE_ASSET__S3j2x$JF__"